function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "home",
  transform: "translate(0 -12.675)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(0 12.676)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M19.664,21.121l-1.69-1.539v-5.1a.588.588,0,0,0-.588-.588H13.32a.588.588,0,0,0-.588.588V14.8l-2.04-1.859a1.021,1.021,0,0,0-1.382,0L.336,21.121A1.026,1.026,0,0,0,1.027,22.9H2.46V31.1a.588.588,0,0,0,.588.588H7.967a.588.588,0,0,0,.588-.588V26.123h2.891V31.1a.588.588,0,0,0,.588.588h4.918a.588.588,0,0,0,.588-.588V22.9h1.433a1.026,1.026,0,0,0,.691-1.784Zm-2.712.607a.588.588,0,0,0-.588.588v8.192H12.622V25.535a.588.588,0,0,0-.588-.588H7.967a.588.588,0,0,0-.588.588v4.974H3.636V22.317a.588.588,0,0,0-.588-.588H1.416L10,13.907l2.923,2.664a.588.588,0,0,0,.984-.435V15.065H16.8v4.776a.588.588,0,0,0,.192.435l1.594,1.452Z",
  transform: "translate(0 -12.676)",
  fill: "#fff"
})));

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.01,
    viewBox: "0 0 20 19.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.bb4ba9a9.svg";
export { ForwardRef as ReactComponent };